import websocketActionTypes from '../actionTypes/websocket.actionTypes'
import { WebSocketRequestMessage_Subscription } from '../proto/generated/websocket'
import { ActionType } from './common.reducer'

interface StateType {
    subscriptionList: WebSocketRequestMessage_Subscription
}

const initialState: StateType = {
    subscriptionList: {
        candleSubscriptions: [],
        securitySnapshotSubscriptions: [],
        orderBookSubscriptions: [],
        watchlistSubscriptions: []
    }
}

export default function websocketReducer(state = initialState, action: ActionType) {
    const { type, payload } = action

    switch (type) {
        case websocketActionTypes.SET_WEBSOCKET_SUBSCRIBE_LIST:
            const currentList = { ...state.subscriptionList }
            const newList: WebSocketRequestMessage_Subscription = payload
            newList.candleSubscriptions.forEach((s) => {
                const found = currentList.candleSubscriptions.findIndex((i) => i.tag === s.tag)
                s.securities = s.securities
                    .filter((s) => s.code)
                    .map((sec) => {
                        return {
                            exchange: sec.exchange,
                            code: sec.code
                        }
                    })
                if (found >= 0) {
                    currentList.candleSubscriptions[found] = s
                } else {
                    currentList.candleSubscriptions.push(s)
                }
            })
            newList.securitySnapshotSubscriptions.forEach((s) => {
                const found = currentList.securitySnapshotSubscriptions.findIndex((i) => i.tag === s.tag)
                s.securities = s.securities
                    .filter((s) => s.code)
                    .map((sec) => {
                        return {
                            exchange: sec.exchange,
                            code: sec.code
                        }
                    })
                if (found >= 0) {
                    currentList.securitySnapshotSubscriptions[found] = s
                } else {
                    currentList.securitySnapshotSubscriptions.push(s)
                }
            })
            newList.orderBookSubscriptions.forEach((s) => {
                const found = currentList.orderBookSubscriptions.findIndex((i) => i.tag === s.tag)
                s.securities = s.securities
                    .filter((s) => s.code)
                    .map((sec) => {
                        return {
                            exchange: sec.exchange,
                            code: sec.code
                        }
                    })
                if (found >= 0) {
                    currentList.orderBookSubscriptions[found] = s
                } else {
                    currentList.orderBookSubscriptions.push(s)
                }
            })
            newList.watchlistSubscriptions.forEach((s) => {
                const found = currentList.watchlistSubscriptions.findIndex((i) => i.tag === s.tag)
                if (found >= 0) {
                    currentList.watchlistSubscriptions[found] = s
                } else {
                    currentList.watchlistSubscriptions.push(s)
                }
            })
            currentList.candleSubscriptions = currentList.candleSubscriptions.filter((o) => o.securities.length > 0)
            currentList.securitySnapshotSubscriptions = currentList.securitySnapshotSubscriptions.filter((o) => o.securities.length > 0)
            currentList.orderBookSubscriptions = currentList.orderBookSubscriptions.filter((o) => o.securities.length > 0)
            currentList.watchlistSubscriptions = currentList.watchlistSubscriptions.filter((o) => o.WatchlistIds.length > 0)
            return {
                ...state,
                subscriptionList: currentList
            }
        default:
            return state
    }
}
